export default __webpack_public_path__ + "static/css/c485dea80e93866bad4e4acc9385979e.css";